module.exports = __webpack_public_path__ + "static/img/PH@3x.3c89c0de.png";